export default "__VITE_ASSET__DSiR2VYd__"